/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DateComplete
 */
export interface DateComplete {
    /**
     * 
     * @type {string}
     * @memberof DateComplete
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof DateComplete
     */
    value: string;
}

export function DateCompleteFromJSON(json: any): DateComplete {
    return DateCompleteFromJSONTyped(json, false);
}

export function DateCompleteFromJSONTyped(json: any, ignoreDiscriminator: boolean): DateComplete {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'title': json['title'],
        'value': json['value'],
    };
}

export function DateCompleteToJSON(value?: DateComplete | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'title': value.title,
        'value': value.value,
    };
}


